import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_closing_balance = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    
    const response = await axios.post(`${APIURL}/create-closing-balance`, data, config);
    return response?.data;
  } catch (error) {
    return error?.response?.data || { status: false, message: error.message };
  }
};

const get_all_closing_balances = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    
    const response = await axios.post(`${APIURL}/get-all-closing-balances`, data, config);
    return response?.data;
  } catch (error) {
    return error?.response?.data || { status: false, message: error.message };
  }
};

const get_closing_balance_by_period = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    
    const response = await axios.post(`${APIURL}/get-closing-balance-by-period`, data, config);
    return response?.data;
  } catch (error) {
    return error?.response?.data || { status: false, message: error.message };
  }
};

const get_available_periods = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    
    const response = await axios.post(`${APIURL}/get-available-periods`, data, config);
    return response?.data;
  } catch (error) {
    return error?.response?.data || { status: false, message: error.message };
  }
};

const toggle_period_lock = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    
    const response = await axios.post(`${APIURL}/toggle-period-lock`, data, config);
    return response?.data;
  } catch (error) {
    return error?.response?.data || { status: false, message: error.message };
  }
};

const get_running_balance = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    
    const response = await axios.post(`${APIURL}/get-running-balance`, data, config);
    return response?.data;
  } catch (error) {
    return error?.response?.data || { status: false, message: error.message };
  }
};

const delete_closing_balance = async (id) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const data = {
      id : id
    }

    const response = await axios.post(`${APIURL}/delete-closing-balance`, data, config);

    if (response?.data?.status_code === 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    }
    return response?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

const get_closing_balance = async (id) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const data = {
      id : id
    }

    const response = await axios.post(`${APIURL}/get-closing-balance`, data, config);

    if (response?.data?.status_code === 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    }
    return response?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export {
  create_closing_balance,
  get_all_closing_balances,
  get_closing_balance_by_period,
  get_available_periods,
  toggle_period_lock,
  get_running_balance,
  delete_closing_balance, 
  get_closing_balance
};